import React from "react";

import { styled } from "styled-components";

import { Row } from "../../components";
import { colorCSS, Colors, gradientCSS } from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

const borderWidth = 6; //px
const dotSize = 2.25; //rem

export const Storyline: React.FC<
    Colors & React.HTMLAttributes<HTMLElement>
> = ({
    background,
    color,
    linkColor,
    linkHoverColor,
    medium,
    headingColor,
    borderColor,
    ...props
}) => {
    const style: React.CSSProperties = {
        ...(background && { background }),
        ...(color && { color })
    };
    // Note: Media queries and pseudo-elements (::after) cannot be applied via inline styles in SSR
    // The vertical line and dot decorations would need CSS classes
    return <section style={style} {...props} />;
};

export const StorylineRow = styled(Row)`
    @media (min-width: 768px) {
        ${redundantCssFromKebab("position", "relative")}

        &:after {
            ${redundantCssFromKebab("background", `${colorCSS("P300")}`)}
            ${redundantCssFromKebab(
                "border",
                `${borderWidth * 0.9}px solid currentColor`
            )}
            ${redundantCssFromKebab("border-radius", "50%")}
            ${redundantCssFromKebab("content", '""')}
            ${redundantCssFromKebab("height", `${dotSize}rem`)}
            ${redundantCssFromKebab("left", "50%")}
            ${redundantCssFromKebab(
                "margin",
                `${3.1 + dotSize}rem 0 0 -${dotSize / 2}rem`
            )}
            ${redundantCssFromKebab("position", "absolute")}
            ${redundantCssFromKebab("width", `${dotSize}rem`)}
            ${redundantCssFromKebab("z-index", "1")}
        }

        &.active:after {
            ${redundantCssFromKebab(
                "background",
                `${gradientCSS("WP300", 90)}`
            )}
        }
    }
`;
